var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"otzyvy-page small-scroll-bar small-scroll-bar--black"},[_c('SuReviews',{attrs:{"title-type":"h1","title-text":"отзывы учеников и&nbsp;родителей <br><span>со всего мира</span>"}}),_vm._v(" "),_c('otzyvy-form'),_vm._v(" "),_c('SuFaq'),_vm._v(" "),_c('school-new-breadcrumbs',{attrs:{"breadcrumbs":_vm.breadcrumbs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }